import {
  Component, OnInit, Renderer2, ElementRef,
  Input, HostBinding, ChangeDetectorRef, ChangeDetectionStrategy,
} from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { BrandService } from 'shared/brand/brand.service';
import { PermissionsService } from 'shared/permissions/permissions.service';
import { SearchModel } from 'shared/search/search.model';

import { StatusModel } from 'shared/search/status.model';

import { DashboardSearchService } from './dashboard-search.service';
import { DashboardSearchComponent } from './base/dashboard-search.component';


@Component({
  moduleId: module.id,
  selector: 'dashboard-search-review',
  templateUrl: './base/dashboard-search.component.html',
  styleUrls: ['./base/dashboard-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardSearchReviewComponent extends DashboardSearchComponent {

  name: string = 'in-review';
  text: string = 'In review';
  count: number = 0;
  statusId: number = 1; // IN REVIEW

  @Input() invalid: boolean = false;

  constructor(
    protected brandService: BrandService,
    protected permissionsService: PermissionsService,
    protected searchService: DashboardSearchService,
    protected router: Router,
    protected _renderer: Renderer2,
    protected ref: ChangeDetectorRef,
    public elementRef: ElementRef,
  ) {
    super(
      brandService,
      permissionsService,
      searchService,
      router,
      _renderer,
      ref,
      elementRef,
    );
  }

  /*******************************************
   * COMPONENT PROTECTED METHODS
   *******************************************/

  get link(): string {
      return '/my-products/working';
  }

  protected initSearchModel() {
    this.searchModel = new SearchModel();
    this.searchModel.route = 'working';
    this.searchModel.statusModel = new StatusModel();
    this.searchModel.statusModel.id = this.statusId;
    this.searchModel.itemsPerPage = 1;
  }

  protected setData(data: any) {
    this.count = _.get(data, 'total', '--');
    this.updateStatusModel(data);
  }

}
